export const experienceData = [
    {
        id: 1,
        company: 'AURA LABS, HongKong',
        jobtitle: 'Professional Frontend Developer',
        startYear: '2017',
        endYear: '2019'
    },
    {
        id: 2,
        company: 'VACUUMLABS, HongKong',
        jobtitle: 'Professional Full Stack Developer',
        startYear: '2019',
        endYear: '2021'
    },
    {
        id: 3,
        company: 'TELESCOPIC, London',
        jobtitle: 'Senior Full Stack Engineer',
        startYear: '2021',
        endYear: '2023'
    },
]